jQuery(document).ready(function(){
	jQuery('.mobileNavToggle').click(function(event){
		jQuery(this).toggleClass('active');
		jQuery('header .myAccount').toggleClass('active');
	});
	jQuery('.closeNav').click(function(event){
		jQuery('header .myAccount').toggleClass('active');
	});

	

	jQuery('.collapseBtn').click(function(event){
		jQuery('body').toggleClass('activeCollapse');
	});
	jQuery('.myAccount .dropdownSub').click(function(event){
		jQuery(this).toggleClass('active');
		jQuery(this).find('ul').stop().slideToggle();
	});

	var addNewSpan = '<small class="open"></small>';
	
	jQuery('.leftNav ul ul').before(addNewSpan);

	jQuery("small.open").click(function() {
		var current=jQuery(this).next('ul');
			jQuery("small.open").next('ul').each(function() {
			if(current.attr('id')!=jQuery(this).attr("id") && jQuery(this).attr("id"))
			{	 
				jQuery(this).prev('small.open').removeClass("active");
				jQuery(this).hide('slow');
			}
		});

		jQuery(this).toggleClass('active');
	    jQuery(this).next('ul').slideToggle(500);
    });
    jQuery('body').on('click','.info .informationTooltip',function(){
		jQuery(this).siblings('.popover').toggle();
	});

	jQuery('body').on("keyup",'.checkPasswordValidation' ,/**/_.debounce(checkPasswordValidation, 500)/**/)
	.on("mouseleave",'.checkPasswordValidation' ,function(){
		$(".passwordRule").hide();
	} );

	let checkPasswordValidationSequence = 0;

	function checkPasswordValidation(evnt) {
		++checkPasswordValidationSequence;
		const callbackSequence = (checkPasswordValidationSequence + 0);
		const password = $(".checkPasswordValidation").val();

		axios.post('/user/invite/password/check-strength', {'password': password}).then((response) => {
			if(callbackSequence !== checkPasswordValidationSequence)
			{
				return;
			}
			if(!response.data.valid_password) {
				const has_digit = response.data.has_digit;
				const has_lower_case = response.data.has_lower_case;
				const has_upper_case = response.data.has_upper_case;
				const has_symbol = response.data.has_symbol;
				const missing_characters = response.data.missing_characters;
				const missing_complexity = response.data.missing_complexity;


				if (missing_characters <= 0) {
					$(".passwordRule .min8char").css('display', 'none');
					$(".passwordRule .min8char").addClass(" green").removeClass("red");
					$(".passwordRule .min8char .close1").css("display", "none").addClass(" red");
					$(".passwordRule .min8char .check1").css("display", "").addClass(" green");
				} else {
					$(".passwordRule .min8char").show();
					$(".passwordRule .min8char").text('At least '+(password.length + missing_characters)+' characters ('+(missing_characters)+' more)');
					$(".passwordRule .min8char").addClass(" red").removeClass("green");
					$(".passwordRule .min8char .close1").css("display", "").addClass(" red");
					$(".passwordRule .min8char .check1").css("display", "none").addClass(" green");
				}
				if (missing_complexity <= 0) {
					$(".passwordRule .sequence").addClass(" green").removeClass("red");
					$(".passwordRule .sequence .close1").css("display", "none").addClass(" red");
					$(".passwordRule .sequence .check1").css("display", "").addClass(" green");
				} else {
					$(".passwordRule .sequence").addClass(" red").removeClass("green");
					$(".passwordRule .sequence .close1").css("display", "").addClass(" red");
					$(".passwordRule .sequence .check1").css("display", "none").addClass(" green");
				}
				if (has_lower_case) {
					$(".passwordRule .min1lowerletter").addClass(" green").removeClass("red");
					$(".passwordRule .min1lowerletter .close1").css("display", "none").addClass(" red");
					$(".passwordRule .min1lowerletter .check1").css("display", "").addClass(" green");
				} else {
					$(".passwordRule .min1lowerletter").addClass(" red").removeClass("green");
					$(".passwordRule .min1lowerletter .close1").css("display", "").addClass(" red");
					$(".passwordRule .min1lowerletter .check1").css("display", "none").addClass(" green");
				}
				if (has_lower_case || has_upper_case) {
					$(".passwordRule .min1letter").addClass(" green").removeClass("red");
					$(".passwordRule .min1letter .close1").css("display", "none").addClass(" red");
					$(".passwordRule .min1letter .check1").css("display", "").addClass(" green");
				} else {
					$(".passwordRule .min1letter").addClass(" red").removeClass("green");
					$(".passwordRule .min1letter .close1").css("display", "").addClass(" red");
					$(".passwordRule .min1letter .check1").css("display", "none").addClass(" green");
				}
				if (has_digit) {
					$(".passwordRule .min1number").addClass(" green").removeClass("red");
					$(".passwordRule .min1number .close1").css("display", "none").addClass(" red");
					$(".passwordRule .min1number .check1").css("display", "").addClass(" green");
				} else {
					$(".passwordRule .min1number").addClass(" red").removeClass("green");
					$(".passwordRule .min1number .close1").css("display", "").addClass(" red");
					$(".passwordRule .min1number .check1").css("display", "none").addClass(" green");
				}
				if (has_upper_case) {
					$(".passwordRule .min1upperletter").addClass(" green").removeClass("red");
					$(".passwordRule .min1upperletter .close1").css("display", "none").addClass(" red");
					$(".passwordRule .min1upperletter .check1").css("display", "").addClass(" green");
				} else {
					$(".passwordRule .min1upperletter").addClass("red").removeClass("green");
					$(".passwordRule .min1upperletter .close1").css("display", "").addClass(" red");
					$(".passwordRule .min1upperletter .check1").css("display", "none").addClass(" green");
				}
				if (has_symbol) {
					$(".passwordRule .min1symbol").addClass(" green").removeClass("red");
					$(".passwordRule .min1symbol .close1").css("display", "none").addClass(" red");
					$(".passwordRule .min1symbol .check1").css("display", "").addClass(" green");
				} else {
					$(".passwordRule .min1symbol").addClass(" red").removeClass("green");
					$(".passwordRule .min1symbol .close1").css("display", "").addClass(" red");
					$(".passwordRule .min1symbol .check1").css("display", "none").addClass(" green");
				}

				$(".passwordRule").show();
			}
			else {
				$(".passwordRule").css('display', 'none');
			}
		}).catch(error => {
			console.error(error);
		});
	}
});


